module.exports = __webpack_public_path__ + "img/20200702_172457.8e10cdad.jpg";